<section class="container-fluid">
  <div class="row">
    <form class="needs-validation container-style" novalidate [formGroup]="formCompany">
      <div class="row mt-1">
        <div class="col-lg-12 col-12">
          <div class="row">
            <div class="col-lg-6 col-md-12 col-sm-12 col-12">
              <app-custom-autocomplete formControlName="articleIdFixedQuota" [labelText]="'Artículo Cuota Fija'"
                [list]="listArticles">
              </app-custom-autocomplete>
            </div>
            <div class="col-lg-6 col-md-12 col-sm-12 col-12">
              <app-custom-autocomplete formControlName="conceptInvoicingIdFixedQuota"
                [labelText]="'Concepto Fra. Cuota Fija'" [list]="listConceptInvoicing">
              </app-custom-autocomplete>
            </div>
            <div class="col-lg-6 col-md-12 col-sm-12 col-12">
              <app-custom-autocomplete formControlName="conceptInvoicingIdSale"
                [labelText]="'Concepto Fra. Venta Nuevo'" [list]="listConceptInvoicing">
              </app-custom-autocomplete>
            </div>
            <div class="col-lg-6 col-md-12 col-sm-12 col-12">
              <app-custom-autocomplete formControlName="conceptInvoicingIdReplacement"
                [labelText]="'Concepto Fra. Venta Usado'" [list]="listConceptInvoicing">
              </app-custom-autocomplete>
            </div>
            <div class="col-lg-6 col-md-12 col-sm-12 col-12">
              <app-custom-select formControlName="countryId" [labelText]="'País'" [list]="listCountry"
                [required]="true">
              </app-custom-select>
            </div>
            <div class="col-lg-6 col-md-12 col-sm-12 col-12">
              <app-custom-select formControlName="currencyId" [labelText]="'Moneda'" [list]="listCurrency"
                [required]="true">
              </app-custom-select>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6 col-6">
              <app-custom-input-number formControlName="ivaRate" [labelText]="'Tarifa Iva'"
                [required]="true"></app-custom-input-number>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6 col-6">
              <app-custom-input-number formControlName="reteIvaRate" [labelText]="'Tarifa ReteIva'"
                [required]="true"></app-custom-input-number>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6 col-6">
              <app-custom-input-number formControlName="invoiceDecimals" [labelText]="'Nro.Decimales Fra.'"
                [required]="true"></app-custom-input-number>
            </div>
            <div class="field-checkbox">
              <app-custom-checkbox formControlName="swSortByInvoicingCodeGroup"
                [labelText]="'Ord.Imp.Facturación'"></app-custom-checkbox>
            </div>
            <div class="col-lg-6 col-md-12 col-sm-12 col-12" [hidden]="!swAdvanceInvoice">
              <app-custom-autocomplete formControlName="articleIdDifferenceAdvanceInvoice"
                [labelText]="'Artículo Diferencia Fra.Anticipada'" [list]="listArticles">
              </app-custom-autocomplete>
            </div>
            <div class="row">
              <div class="col field-button">
                <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [severity]="'primary'" [variant]="undefined"
                  [disabled]="disabledForm" (onClick)="send()">
                </app-custom-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>